import { getToken } from "services/auth/tokenAuth";
import doRequest from "./client";
import { getUserId } from "services/storage/general";
import { EMPLOYABILITY_ENDPOINTS } from "./constants";
import {
    mapAdminReservationSearchRequest,
    mapBaseResponse,
    mapReservationDetailToUI
} from "./mappers";

export const requestSearchAdminReservations = async filters => {
    const [result, err] = await doRequest(
        EMPLOYABILITY_ENDPOINTS.ADMIN_RESERVATIONS_SEARCH,
        "POST",
        mapAdminReservationSearchRequest({
            ...filters,
            userCode: getUserId()
        }),
        getToken()
    );
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success ? response.data?.items || [] : null;
};

export const requestGetAdminReservationDetail = async reservationId => {
    const endpoint = `${EMPLOYABILITY_ENDPOINTS.ADMIN_RESERVATION_DETAIL(reservationId)}?codigoUsuario=${encodeURIComponent(getUserId())}`;
    const [result, err] = await doRequest(endpoint, "GET", null, getToken());
    if (err) return null;
    const response = mapBaseResponse(result);
    return response.success
        ? mapReservationDetailToUI(response.data?.reserva || response.data)
        : null;
};

export const requestGetDateOfNextReservation = async studentText => {
    const reservations = await requestSearchAdminReservations({ studentText });
    if (!reservations?.length) return null;
    const nextReservation = [...reservations].sort((a, b) => a.fecha - b.fecha)[0];
    return {
        date: nextReservation.fecha,
        studentId: nextReservation.codigoAlumno
    };
};

export const requestGetDateAsPaginated = async (studentId, currentIndex, next) => {
    const reservations = await requestSearchAdminReservations({
        studentCode: studentId
    });
    if (!reservations?.length) return null;
    const dates = [...new Set(reservations.map(item => item.fecha))].sort((a, b) => a - b);
    const targetIndex = Math.max(0, currentIndex - 1) + (next ? 1 : -1);
    return dates[Math.max(0, Math.min(targetIndex, dates.length - 1))];
};
